import { useSnapshot } from '@framework/hooks/useSnapshot';
import { RTDBPath } from 'balus-common';
import { Viewer } from '@view-model/Viewer/Viewer';
import type { ViewerJSON, ViewModelId } from 'balus-common';
import { useSetAtom } from 'jotai/react';
import { viewersAtom } from '@view-model/models/sticky/viewers/viewersAtom';
import { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
// viewersAtomにビューモデルを閲覧中のユーザ情報を読み込む
export const ViewersLoader = ({ viewModelId }: { viewModelId: ViewModelId }) => {
  const { t } = useTranslation();
  const setViewers = useSetAtom(viewersAtom);

  useSnapshot({
    path: RTDBPath.ViewModelViewer.viewersPath(viewModelId),
    stateless: true,
    load: ({ getChildValues }) => {
      const viewersJSON = getChildValues() as Record<string, ViewerJSON>;
      const viewers = Object.values(viewersJSON).map((viewerJSON) => Viewer.load(viewerJSON));
      setViewers(viewers);
    },
    onError: () => {
      toast.error(t('common.message.loadFailed'));
    },
  });

  useEffect(() => {
    return () => {
      setViewers([]);
    };
  }, [setViewers]);

  return null;
};
